import { render, staticRenderFns } from "./FiltrosTipo2.vue?vue&type=template&id=6a41db1c&scoped=true&"
import script from "./FiltrosTipo2.vue?vue&type=script&lang=js&"
export * from "./FiltrosTipo2.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosTipo2.vue?vue&type=style&index=0&id=6a41db1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41db1c",
  null
  
)

export default component.exports